import { useContext } from 'react';
import { Grid } from '@mui/material';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { appUserContext } from 'helpers/services';
import DesktopVersion from './DesktopVersion';
import MobileVersion from './MobileVersion';
import ManagePeople from './ManagePeople';


let People = () => {
    const { currentUser, isMobile } = useContext(appUserContext);
    const service = useContext(ticketDetailsContext);

    return (
        <Grid container>
            <Grid item xs={12}>
                {isMobile === false && <DesktopVersion />}
                {isMobile === true && <MobileVersion />}
            </Grid>
            {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                <ManagePeople />
            }
        </Grid>
    )
}

export default People;